<div class="container-login">
  <div class="login-wrapper">
    <div class="login-card" *ngIf="!navigating">
      <div class="logo">
        <img src="../../../../assets/svg/logo.svg" alt="Logo" />
      </div>
      <div *ngIf="loadingLogin || !authService.isLoggedIn()" class="header">
        <h3 class="welcome">Welcome</h3>
        <p>Please enter your details to Log In</p>
      </div>
      <form #f="ngForm" (ngSubmit)="onLogin(f.value.email, f.value.password)" *ngIf="loadingLogin || !authService.isLoggedIn()">
        <div>
          <label>Email</label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput placeholder="email" type="email" name="email" id="email" (ngModel)="email" />
          </mat-form-field>
        </div>
        <div class="password-container">
          <mat-label>Password</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput placeholder="password" type="password" name="password" id="password" (ngModel)="password" />
          </mat-form-field>
        </div>
        <div class="forgot-password">
          <a class="forgot-password-link" [routerLink]="['/confirm-email']">Forgot password?</a>
        </div>

        <flow-button theme="primary" variation="fill" type="submit" [fullWidth]="true" [disabled]="loadingLogin">Log In</flow-button>
      </form>
      <div *ngIf="!loadingLogin && authService.isLoggedIn()">
        <p class="text-center mb-6">{{ 'login.info' | translate }} {{authService.user?.email}}.</p>
        <div class="flex flex-row gap-4 justify-center">
          <flow-button theme="primary" variation="fill" type="button" (onClick)="logout()">
            {{ 'login.logOut' | translate }}
          </flow-button>
          <flow-button theme="secondary" variation="outline" type="button" [routerLink]="['/home']">
            <mat-icon class="mr-2" inline="true">home</mat-icon>
            {{ 'login.toHome' | translate }}
          </flow-button>
        </div>
      </div>
    </div>
    <div>
      <p>© BizLab Analytics {{currentYear}}</p>
    </div>
  </div>
  <div class="image-wrapper"></div>
</div>
